import appGlobalScript from '/builds/congo-web/libraries/ui/components/cui-modal/src/global.ts';
export const globalScripts = appGlobalScript;
